var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pdng-1"},[_c('div',{staticClass:"centered-row"},[_c('div',{staticClass:"loading"},[_c('Fai',{attrs:{"icon":['far', 'circle-notch'],"spin":""}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }